import React from 'react';
import { format } from 'react-string-format';
import Pusher from 'pusher-js';
import {withRouter} from "../withRouter";
import axios from "axios";

class ManageGamePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            iconUrl: null,
            backgroundImage: null,
            descriptionImages: null,
            iconIsLoading:true,
            backgroundImageIsLoading:true,
            descriptionImagesIsLoading: true,
        };
    }

    componentDidMount() {
        this.setState({
            iconUrl: this.props.game.game_page ? this.props.game.game_page.icon_url : null,
            backgroundImage: this.props.game.game_page ? this.props.game.game_page.background_image_url : null,
            descriptionImages: this.props.game.game_page ? this.props.game.game_page.description_images : null,
            iconIsLoading:false,
            backgroundImageIsLoading:false,
            descriptionImagesIsLoading: false,
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        const { navigate } = this.props;

        const body = {
            'short_description': e.target.short_description.value,
            'long_description': e.target.long_description.value
        };

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/update/page', this.props.game.id.toString()), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {
                'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`
            }
        }).then((response) => {
            console.log(response);
            console.log(JSON.stringify(body));
            window.location.reload(false);
        });
    }

    render() {
        let icon = null;
        if(this.state.iconIsLoading) {
            icon = <div class="alert alert-warning">Processing image file...</div>
        } else if (this.state.iconUrl) {
            icon = <div>
                <img width="100px" style={{borderRadius: 5}} src={this.state.iconUrl}></img>
                <br/>
            </div>;
        }

        let background = null;
        if(this.state.backgroundImageIsLoading) {
            background = <div class="alert alert-warning">Processing image file...</div>
        } else if (this.state.iconUrl) {
            background = <div>
                <img width="100px" style={{borderRadius: 5}} src={this.state.backgroundImage}></img>
                <br/>
            </div>;
        }

        let descriptionImages = null;
        if(this.state.descriptionImagesIsLoading) {
            descriptionImages = <div class="alert alert-warning">Processing image file...</div>
        } else if (this.state.descriptionImages) {
            descriptionImages = this.state.descriptionImages.map(img => (
                    <img width="100px" style={{borderRadius: 5}} src={img}></img>
            ));
        }

        return (
            <div>
                <h1>Your game page:</h1>
                <a href='#'>View it</a>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <label>Short description: </label>
                    <input class="form-control" type="text" name="short_description" defaultValue={this.props.game.game_page ? this.props.game.game_page.short_description : ''}/>
                    <br/>
                    <label>Long description: </label>
                    <input class="form-control" type="text" name="long_description" defaultValue={this.props.game.game_page ? this.props.game.game_page.long_description : ''}/>
                    <br/>
                    <input className="btn btn-success" type="submit" value="Save"/>
                    <br/>
                    <label>Icon: </label>
                    {icon}
                    <input class="form-control-file" type="file" name="icon_url" onChange={
                        async (e) => {
                            let formData = new FormData();
                            formData.append("icon", e.target.files[0]);

                            this.setState({
                                iconIsLoading: true
                            });

                            const resp = await axios.post(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/page/upload/icon', this.props.game.id.toString()), formData, {
                                headers: {
                                    "content-type": "multipart/form-data",
                                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`,
                                },
                            });

                            this.setState({
                                iconUrl: URL.createObjectURL(e.target.files[0]),
                                iconIsLoading: false
                            });
                        }
                    }/>
                    <br/><br/>
                    <label>Background image: </label>
                    {background}
                    <input  class="form-control-file" type="file" name="background_image_url" onChange={
                        async (e) => {
                            let formData = new FormData();
                            formData.append("background_image", e.target.files[0]);

                            this.setState({
                                backgroundImageIsLoading: true
                            });

                            const resp = await axios.post(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/page/upload/background', this.props.game.id.toString()), formData, {
                                headers: {
                                    "content-type": "multipart/form-data",
                                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`,
                                },
                            });

                            this.setState({
                                backgroundImage: URL.createObjectURL(e.target.files[0]),
                                backgroundImageIsLoading: false
                            });
                        }
                    }/>
                    <br/><br/>
                    <label>Description images: </label>
                    <br/>
                    {descriptionImages}
                    <br/>
                    <input class="form-control-file" type="file" multiple name="description_images" onChange={
                        async (e) => {
                            let formData = new FormData();
                            let files = [];
                            for(let i=0; i<e.target.files.length; i++) {
                                formData.append("description_images[]", e.target.files[i]);
                                files.push(URL.createObjectURL(e.target.files[i]));
                            }

                            this.setState({
                                descriptionImagesIsLoading: true
                            });

                            const resp = await axios.post(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/page/upload/description', this.props.game.id.toString()), formData, {
                                headers: {
                                    "content-type": "multipart/form-data",
                                    "Authorization": `Bearer ${sessionStorage.getItem('token')}`
                                },
                            });

                            this.setState({
                                descriptionImages: files,
                                descriptionImagesIsLoading: false
                            });
                        }
                    }/>

                </form>
            </div>
        );
    }
}

export default withRouter(ManageGamePage);
